import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import { useAuth } from "../util/auth";
import { getIsVendor } from "../util/db";

function VendorPage() {
  const auth = useAuth();
  const uid = auth.user?.uid;
  const [isVendor, setIsVendor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check vendor status when component mounts or uid changes
  useEffect(() => {
    if (uid) {
      const vendorCheck = getIsVendor(uid);
      vendorCheck
        .then((result) => {
          setIsVendor(result.is_vendor);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error checking vendor status:", error);
          setIsVendor(false);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [uid]);

  // Show unauthorized message if user is not logged in
  if (!auth.user) {
    return (
      <Container fluid className="py-4">
        <Row>
          <Col lg={12}>
            <Card
              className="mb-4"
              style={{
                borderRadius: "10px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Card.Header
                style={{
                  background: "#dc3545",
                  color: "white",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <Card.Title className="mb-0" style={{ color: "white" }}>
                  Access Denied
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ background: "#FFFFFF" }}>
                <Alert variant="danger">
                  <Alert.Heading>Not Authorized</Alert.Heading>
                  <p>
                    You must be logged in to access the vendor dashboard. Please
                    sign in and ensure you have vendor privileges.
                  </p>
                </Alert>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  // Show loading state while checking vendor status
  if (isLoading) {
    return (
      <Container fluid className="py-4">
        <Row>
          <Col lg={12}>
            <Card
              className="mb-4"
              style={{
                borderRadius: "10px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Card.Body style={{ background: "#FFFFFF" }}>
                <div className="text-center py-4">
                  <p>Loading...</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  // Show unauthorized message if user is not a vendor
  if (!isVendor) {
    return (
      <Container fluid className="py-4">
        <Row>
          <Col lg={12}>
            <Card
              className="mb-4"
              style={{
                borderRadius: "10px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Card.Header
                style={{
                  background: "#dc3545",
                  color: "white",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <Card.Title className="mb-0" style={{ color: "white" }}>
                  Access Denied
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ background: "#FFFFFF" }}>
                <Alert variant="danger">
                  <Alert.Heading>Not Authorized</Alert.Heading>
                  <p>
                    You are not authorized to access the vendor dashboard.
                    Please contact an administrator if you believe this is an
                    error.
                  </p>
                </Alert>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  // Show vendor dashboard if user is authorized
  return (
    <Container fluid className="py-4">
      <Row>
        <Col lg={12}>
          <Card
            className="mb-4"
            style={{
              borderRadius: "10px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Card.Header
              style={{
                background: "#2D083F",
                color: "white",
                borderRadius: "10px 10px 0 0",
              }}
            >
              <Card.Title className="mb-0" style={{ color: "white" }}>
                Vendor Dashboard
              </Card.Title>
            </Card.Header>
            <Card.Body style={{ background: "#FFFFFF" }}>
              <div className="text-center py-4">
                <h4>Welcome to the Vendor Dashboard</h4>
                <p className="text-muted">
                  Vendor tools and features will be available here.
                </p>
                <p>
                  <strong>Logged in as:</strong> {auth.user?.email}
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default VendorPage;
